<div *ngIf="initialized && !embedMode" class="subscriptionSchedulerModal modalOverlay" style="z-index:1600">
    <div class="modalPositioner" [ngClass] = "{ 'hasTimeZone' : hasTimeZone }" cvNavigationSidebarClass>
        <div class="modalContainer">
            <!-- Header -->
            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail modal-close" (click)="clickCancel()">
                <svg class="icon-16">
                    <use href="../../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                </svg>
            </button>
            <div class="modalHeader">
                <span class="titleText">{{ subscriptionTitle }}</span>
                <div class="stepperContainer">
                    <div class=""></div>
                </div>
            </div>

            <!-- Body -->
            <!-- Loading Graphic -->
            <cv-loader [hidden]="!isLoading"></cv-loader>

            <!-- Content -->
            <div class="modalBody" *ngIf="!isLoading">

                <!-- Export Type -->
                <div class="bodyRow">
                    <div class="mb-2">
                        <span class="font-weight-bold mb-2" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Export_Type">Export Type</span><span>:</span>
                    </div>
                    <div class="optionRow">
                        <div class="optionContainer form-check form-check-inline" *ngFor="let option of exportTypes">
                            <input type="radio" class="form-check-input" name="subSchedTypeRadio" [attr.id]="'subSchedTypeRadio' + option.value" [(ngModel)]="schedule.exportType" [value]="option.value"/>
                            <label class="optionTitle form-check-label" [attr.for]="'subSchedTypeRadio' + option.value">{{ option.localizedName }}</label>
                        </div>
                    </div>
                </div>

                <!-- Email Frequency -->
                <div class="bodyRow">
                    <!-- Frequency Radio Buttons -->
                    <div class="mb-2">
                        <span class="font-weight-bold" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Email_Frequency">Email Frequency</span><span>:</span>
                    </div>
                    <div class="optionRow">
                        <div class="optionContainer form-check form-check-inline" *ngFor="let option of frequencies">
                            <input type="radio" class="form-check-input" name="subSchedEmailFreqRadio" [attr.id]="'subSchedEmailFreqRadio' + option.value" [(ngModel)]="schedule.frequency" [value]="option.value"/>
                            <label class="optionTitle form-check-label" [attr.for]="'subSchedEmailFreqRadio' + option.value">{{ option.localizedName }}</label>
                        </div>
                    </div>

                    <!-- Occurence Dropdown Selector -->
                    <!-- For frequency "Daily/Weekly -> Day of Month", show the "Day of Month" selector. -->
                    <!-- Ng-If is based on the value of 'Day of Month' in ctrl.frequencies -->
                    <div class="optionRow marginTop16" *ngIf="schedule.frequency == 2">
                        <mat-form-field class="cv-material-control" appearance="fill">
                            <mat-select style="width: 280px;"
                                aria-label="Days of Month"
                                [placeholder]="selectDaysPlaceholder"
                                panelClass="cv-material-control"
                                [disableRipple]="true"
                                [multiple]="true"
                                [(value)]="daysOfMonthSelected"
                                (valueChange)="onChangeSelectedDOM()"
                            >
                                <mat-option *ngFor="let day of daysOfMonthFull" [value]="day">{{ day }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <!-- For frequency "Monthly -> Week of Month", show the "Week(s) of Month" selector. -->
                    <!-- Ng-If is based on the value of 'Week of Month' in ctrl.frequencies -->
                    <div class="optionRow marginTop16" *ngIf="schedule.frequency == 3">
                        <mat-form-field class="cv-material-control" appearance="fill">
                            <mat-select style="width: 280px;"
                                aria-label="Days of Week"
                                [placeholder]="selectWeeksPlaceholder"
                                panelClass="cv-material-control"
                                [disableRipple]="true"
                                [multiple]="true"
                                [(value)]="weeksOfMonthSelected"
                                (valueChange)="onChangeSelectedWOM()"
                            >
                                <mat-option *ngFor="let week of weeksOfMonthFull" [value]="week">{{ week }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <!-- Day Checkboxes -->
                    <!-- Only shows on 'Daily/Weekly' or 'Week of Month' -->
                    <div class="optionRow mt-3" *ngIf="schedule.frequency == 1 || schedule.frequency == 3">
                        <div class="form-check form-check-inline" *ngFor="let day of daysOfWeek">
                            <input type="checkbox" class="form-check-input" [attr.id]="'subSchedDOWCheck' + day.localizedName" [(ngModel)]="day.selected" />
                            <label class="from-check-label mb-0" [attr.for]="'subSchedDOWCheck' + day.localizedName">{{ day.shortName }}</label>
                        </div>
                    </div>

                    <!-- Start & End Dates and Times -->
                    <div class="optionRow mt-3">
                        <div class="timeSelectGroup">
                            <div class="rowSubTitle" cvLocalizedText langSection="Common" langKey="Start">Start</div>
                            <div class="d-flex">
                                <cv-baremetrics-calendar class="d-block daterange daterange--single" [(currentDate)]="schedule.startDate" [required]="true"></cv-baremetrics-calendar>
                                <span class="betweenText" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="To">to</span>
                            </div>
                        </div>
                        <div class="timeSelectGroup">
                            <div class="rowSubTitle" cvLocalizedText langSection="Common" langKey="End">End</div>
                            <div class="d-flex">
                                <cv-baremetrics-calendar class="d-block daterange daterange--single" [(currentDate)]="schedule.endDate" [required]="false"></cv-baremetrics-calendar>
                                <span class="betweenText" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="at">at</span>
                            </div>
                        </div>
                        <div class="timeSelectGroup" style="width: 145px;">
                            <div class="rowSubTitle" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Time">Time</div>
                            <cv-time-picker [(ngModel)]="schedule.firstExportTime"></cv-time-picker>
                        </div>
                        <div *ngIf="hasTimeZone" class="timeSelectGroup" style="width: 300px;">
                            <div class="rowSubTitle" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Time_Zone">Time Zone</div>
                            <span class="timeZoneText" [attr.title]="timezone">{{timezone}}</span>
                        </div>
                    </div>

                    <!-- Extra Export Times -->
                    <div class="optionRow extraTimesRow">
                        <div class="timeSelectGroup" *ngFor="let time of schedule.extraExportTimes; let $index = index">
                            <cv-time-picker [(ngModel)]="schedule.extraExportTimes[$index]"></cv-time-picker>
                            <div class="removeTime" (click)="removeTime($index)"></div>
                        </div>
                    </div>

                    <!-- Repeat Options -->
                    <div class="optionRow repeatRow">
                        <div class="repeatEnable form-check">
                            <input type="checkbox" class="form-check-input" id="subSchedRepeatCheck" [(ngModel)]="schedule.repeatOptions.isRepeat" />
                            <label class="form-check-label mb-0 ml-1" for="subSchedRepeatCheck" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Repeat">Repeat</label>
                        </div>
                    </div>

                    <div class="optionRow repeatRow">
                        <div class="repeatOptions ml-1">
                            <span class="mr-1" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Send_Every">Send Every</span>
                            <input class="form-control d-inline mr-1" style="max-width: 48px;" type="number"
                                [(ngModel)]="schedule.repeatOptions.repeatValue"
                                (ngModelChange)="validateSendEvery()"
                                [ngClass]="{ 'is-invalid': schedule.repeatOptions.isRepeat && isSendEveryInvalid }"
                                [disabled]="!schedule.repeatOptions.isRepeat"
                                />
                            <select class="form-control d-inline mr-1" style="max-width: 64px;"
                                [(ngModel)]="schedule.repeatOptions.repeatType"
                                (ngModelChange)="validateSendEvery()"
                                [disabled]="!schedule.repeatOptions.isRepeat">
                                <option *ngFor="let item of recurringDisplayValues" [ngValue]="item.value">{{ item.localizedName }}</option>
                            </select>
                            <span class="ml-1 mr-2" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="End_At">End At</span>
                            <cv-time-picker [(ngModel)]="schedule.repeatOptions.repeatEnd" [disabled]="!schedule.repeatOptions.isRepeat"></cv-time-picker>
                        </div>
                    </div>
                    <div class="text-danger" [hidden]="!(schedule.repeatOptions.isRepeat && isSendEveryInvalid)">
                        *&nbsp;<span cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Send_Every_Error">Send Every value must be greater than or equal to 15 minutes.</span>
                    </div>
                </div>

                <!-- Recipients -->
                <div class="bodyRow pb-2">
                    <div class="mb-2">
                        <span class="font-weight-bold" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Recipients">Recipients</span><span>:</span>
                    </div>
                    <div class="sendToMe">
                        <input type="checkbox" class="form-check-input" id="subSchedSendToMeCheck" [(ngModel)]="schedule.sendToMe" (ngModelChange)="removeOwner()" />
                        <label class="form-check-label mb-0 ml-1" for="subSchedSendToMeCheck" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Send_To_Me">Send to Me</label>
                        &nbsp;<span>{{ ownerEmail }}</span>
                    </div>
                    <div class="mt-1 mb-1 ml-1" style="font-size:12px" cvLocalizedText langSection="Subscription_Modal" langKey="Duplicate_Emails">All duplicated emails will automatically be removed</div>
                    <div class="recipientsRowContentContainer left">
                        <textarea class="form-control d-inline newRecipients" [(ngModel)]="newRecipients" placeholder="Please comma separate multiple emails."
                        cvLocalizedPlaceholder langSection="Subscriptions_Dashboard" langKey="Instruction_Recipients"
                        (ngModelChange)="validateRecipients()" [ngClass]="{'is-invalid': isRecipientTextareaInvalid}"></textarea>
                        <div class="addNewTime" (click)="addRecipients()" style="margin-left: 3px;"></div>
                    </div>

                    <div class="recipientsRowContentContainer right noLeftMargin">
                        <div class="recipientRow"
                            *ngFor="let recipient of schedule.recipients; let $index = index"
                            (mouseover)="onHoverRecipient(true, $index)"
                            (mouseleave)="onHoverRecipient(false, $index);">
                            <div class="recipientAddress textTruncate" [attr.title]="recipient">{{ recipient }}</div>
                            <div class="removeRecipient"
                                [class.showRemove]="hoveredRecipient == $index"
                                (click)="removeRecipient($index)">
                            </div>
                        </div>
                    </div>
                    <div [hidden]="!isRecipientTextareaInvalid">
                        <div class="text-danger d-flex align-items-center mt-1">
                            <svg class="icon-16 fill-redRyder mr-1"><use href="../../App_Themes/clearview-default/icons/utility/info.svg#info"></use></svg>
                            <span cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Recipients_Invalid_Error">Recipients contains invalid email addresses.</span>
                        </div>
                    </div>
                    <div [hidden]="checkRecipientAdded()">
                        <div class="text-danger d-flex align-items-center mt-1">
                            <svg class="icon-16 fill-redRyder mr-1"><use href="../../App_Themes/clearview-default/icons/utility/info.svg#info"></use></svg>
                            <span cvLocalizedText langSection="Subscriptions_Dashboard" langKey="No_Recipient_Error">At least one recipient must be specified.</span>
                        </div>
                    </div>
                </div>
                <div class="bodyRow pb-3" *ngIf="this.schedule.recipients?.length > 0 && this.schedule.recipients?.length <=100">
                    <div class="optionRow pt-2">
                        <div class="optionContainer form-check form-check-inline">
                            <input type="checkbox" class="form-check-input" name="subSchedRecipientDisplayCheck" [attr.id]="'subSchedRecipientDisplayCheck'" [(ngModel)]="schedule.displayRecipients" [value]="schedule.displayRecipients"/>
                            <label  cvLocalizedText langSection="Subscription_Modal" langKey="Display_Recipients" class="optionTitle form-check-label" [attr.for]="'subSchedRecipientDisplayCheck'">Display recipients in the email?</label>
                        </div>                        
                    </div>
                </div>
            </div>

            <!-- Footer -->
            <div class="modalFooter">
                <div class="d-flex flex-row flex-nowrap justify-content-end my-3">
                    <div class="flex-fill" *ngIf="showDeleteButton">
                        <button type="button" class="btn btn-text btn-icon fill-cerulean" (click)="clickDeleteSubscription()">
                            <svg class="icon-16 fill-cerulean"><use href="../../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use></svg>
                            <span cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Delete_Subscription">Delete Subscription</span>
                        </button>
                    </div>
                    <div>
                        <button type="button" class="btn btn-text mr-2" (click)="clickCancel()" cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</button>
                        <button type="button" class="btn btn-primary" (click)="save()" [disabled]="isSaving" cvLocalizedText langSection="Common" langKey="Save_Button">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<cv-loader *ngIf="isLoading"></cv-loader>

<div *ngIf="initialized && embedMode && !isLoading">
    <!-- Export Type -->
    <div class="bodyRow">
        <div class="mb-2">
            <span class="font-weight-bold" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Export_Type">Export Type</span><span>:</span>
        </div>
        <div class="optionRow">
            <div class="optionContainer form-check form-check-inline" *ngFor="let option of exportTypes">
                <input type="radio" class="form-check-input" name="subSchedTypeRadio" [attr.id]="'subSchedTypeRadio' + option.value" [(ngModel)]="schedule.exportType" [value]="option.value"/>
                <label class="optionTitle form-check-label" [attr.for]="'subSchedTypeRadio' + option.value">{{ option.localizedName }}</label>
            </div>
        </div>
    </div>

    <!-- Email Frequency -->
    <div class="bodyRow">
        <!-- Frequency Radio Buttons -->
        <div class="mb-2">
            <span class="font-weight-bold" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Email_Frequency">Email Frequency</span><span>:</span>
        </div>
        <div class="optionRow">
            <div class="optionContainer form-check form-check-inline" *ngFor="let option of frequencies">
                <input type="radio" class="form-check-input" name="subSchedEmailFreqRadio" [attr.id]="'subSchedEmailFreqRadio' + option.value" [(ngModel)]="schedule.frequency" [value]="option.value"/>
                <label class="optionTitle form-check-label" [attr.for]="'subSchedEmailFreqRadio' + option.value">{{ option.localizedName }}</label>
            </div>
        </div>

        <!-- Occurence Dropdown Selector -->
        <!-- For frequency "Daily/Weekly -> Day of Month", show the "Day of Month" selector. -->
        <!-- Ng-If is based on the value of 'Day of Month' in ctrl.frequencies -->
        <div class="optionRow marginTop16" *ngIf="schedule.frequency == 2">
            <mat-form-field class="cv-material-control" appearance="fill">
                <mat-select style="width: 280px;"
                    aria-label="Days of Month"
                    [placeholder]="selectDaysPlaceholder"
                    panelClass="cv-material-control"
                    [disableRipple]="true"
                    [multiple]="true"
                    [(value)]="daysOfMonthSelected"
                    (valueChange)="onChangeSelectedDOM()"
                >
                    <mat-option *ngFor="let day of daysOfMonthFull" [value]="day">{{ day }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- For frequency "Monthly -> Week of Month", show the "Week(s) of Month" selector. -->
        <!-- Ng-If is based on the value of 'Week of Month' in ctrl.frequencies -->
        <div class="optionRow marginTop16" *ngIf="schedule.frequency == 3">
            <mat-form-field class="cv-material-control" appearance="fill">
                <mat-select style="width: 280px;"
                    aria-label="Days of Week"
                    [placeholder]="selectWeeksPlaceholder"
                    panelClass="cv-material-control"
                    [disableRipple]="true"
                    [multiple]="true"
                    [(value)]="weeksOfMonthSelected"
                    (valueChange)="onChangeSelectedWOM()"
                >
                    <mat-option *ngFor="let week of weeksOfMonthFull" [value]="week">{{ week }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Day Checkboxes -->
        <!-- Only shows on 'Daily/Weekly' or 'Week of Month' -->
        <div class="optionRow mt-3" *ngIf="schedule.frequency == 1 || schedule.frequency == 3">
            <div class="form-check form-check-inline" *ngFor="let day of daysOfWeek">
                <input type="checkbox" class="form-check-input" [attr.id]="'subSchedDOWCheck' + day.name" [(ngModel)]="day.selected" />
                <label class="from-check-label mb-0" [attr.for]="'subSchedDOWCheck' + day.name">{{ day.shortName }}</label>
            </div>
        </div>

        <!-- Start & End Dates and Times -->
        <div class="optionRow mt-3">
            <div class="timeSelectGroup">
                <div class="rowSubTitle" cvLocalizedText langSection="Common" langKey="Start">Start</div>
                <div class="d-flex">
                    <cv-baremetrics-calendar class="d-block daterange daterange--single" [(currentDate)]="schedule.startDate" [required]="true"></cv-baremetrics-calendar>
                    <span class="betweenText" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="To">to</span>
                </div>
            </div>
            <div class="timeSelectGroup">
                <div class="rowSubTitle" cvLocalizedText langSection="Common" langKey="End">End</div>
                <div class="d-flex">
                    <cv-baremetrics-calendar class="d-block daterange daterange--single" [(currentDate)]="schedule.endDate" [required]="false"></cv-baremetrics-calendar>
                    <span class="betweenText" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="at">at</span>
                </div>
            </div>
            <div class="timeSelectGroup" style="width: 145px;">
                <div class="rowSubTitle" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Time">Time</div>
                <cv-time-picker [(ngModel)]="schedule.firstExportTime"></cv-time-picker>
            </div>
            <div *ngIf="hasTimeZone" class="timeSelectGroup">
                <div class="rowSubTitle" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Time_Zone">Time Zone</div>
                <span class="timeZoneText" [attr.title]="timezone">{{timezone}}</span>
            </div>
        </div>

        <!-- Extra Export Times -->
        <div class="optionRow extraTimesRow">
            <div class="timeSelectGroup" *ngFor="let time of schedule.extraExportTimes; let $index = index">
                <cv-time-picker [(ngModel)]="schedule.extraExportTimes[$index]"></cv-time-picker>
                <div class="removeTime" (click)="removeTime($index)"></div>
            </div>
        </div>

        <!-- Repeat Options -->
        <div class="optionRow repeatRow">
            <div class="repeatEnable form-check">
                <input type="checkbox" class="form-check-input" id="subSchedRepeatCheck" [(ngModel)]="schedule.repeatOptions.isRepeat" />
                <label class="form-check-label mb-0 ml-1" for="subSchedRepeatCheck" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Repeat">Repeat</label>
            </div>
        </div>

        <div class="optionRow repeatRow">
            <div class="repeatOptions ml-1">
                <span class="mr-1" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Send_Every">Send Every</span>
                <input class="form-control d-inline mr-1" style="max-width: 48px;" type="number"
                    [(ngModel)]="schedule.repeatOptions.repeatValue"
                    (ngModelChange)="validateSendEvery()"
                    [ngClass]="{ 'is-invalid': schedule.repeatOptions.isRepeat && isSendEveryInvalid }"
                    [disabled]="!schedule.repeatOptions.isRepeat"
                    />
                <select class="form-control d-inline mr-1" style="max-width: 64px;"
                    [(ngModel)]="schedule.repeatOptions.repeatType"
                    (ngModelChange)="validateSendEvery()"
                    [disabled]="!schedule.repeatOptions.isRepeat">
                    <option *ngFor="let item of recurringDisplayValues" [ngValue]="item.value">{{ item.localizedName }}</option>
                </select>
                <span class="ml-1 mr-2" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="End_At">End At</span>
                <cv-time-picker [(ngModel)]="schedule.repeatOptions.repeatEnd" [disabled]="!schedule.repeatOptions.isRepeat"></cv-time-picker>
            </div>
        </div>
        <div class="text-danger" [hidden]="!(schedule.repeatOptions.isRepeat && isSendEveryInvalid)">
            *&nbsp;<span cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Send_Every_Error">Send Every value must be greater than or equal to 15 minutes.</span>
        </div>
    </div>

    <!-- Recipients -->
    <div class="bodyRow pb-3">
        <div class="mb-2">
            <span class="font-weight-bold" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Recipients">Recipients</span><span>:</span>
        </div>
        <div class="sendToMe">
            <input type="checkbox" class="form-check-input" id="subSchedSendToMeCheck" [(ngModel)]="schedule.sendToMe" (ngModelChange)="removeOwner()" />
            <label class="form-check-label mb-0 ml-1" for="subSchedSendToMeCheck" cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Send_To_Me">Send to Me</label>
            &nbsp;<span>{{ ownerEmail }}</span>
        </div>
        <div class="recipientsRowContentContainer left">
            <textarea class="form-control d-inline newRecipients" [(ngModel)]="newRecipients" placeholder="Please comma separate multiple emails."
            cvLocalizedPlaceholder langSection="Subscriptions_Dashboard" langKey="Instruction_Recipients"
            (ngModelChange)="validateRecipients()" [ngClass]="{'is-invalid': isRecipientTextareaInvalid}"></textarea>
            <div class="addNewTime" (click)="addRecipients()" style="margin-left: 2px;"></div>
        </div>

        <div class="recipientsRowContentContainer right noLeftMargin">
            <div class="recipientRow"
                *ngFor="let recipient of schedule.recipients; let $index = index"
                (mouseover)="onHoverRecipient(true, $index)"
                (mouseleave)="onHoverRecipient(false, $index);">
                <div class="recipientAddress textTruncate" [attr.title]="recipient">{{ recipient }}</div>
                <div class="removeRecipient"
                    [class.showRemove]="hoveredRecipient == $index"
                    (click)="removeRecipient($index)">
                </div>
            </div>
        </div>
            <div [hidden]="!isRecipientTextareaInvalid">
                <div class="text-danger d-flex align-items-center mt-1">
                    <svg class="icon-16 fill-redRyder mr-1"><use href="../../App_Themes/clearview-default/icons/utility/info.svg#info"></use></svg>
                    <span cvLocalizedText langSection="Subscriptions_Dashboard" langKey="Recipients_Invalid_Error">Recipients contains invalid email addresses.</span>
                </div>
            </div>
            <div [hidden]="checkRecipientAdded()">
                <div class="text-danger d-flex align-items-center mt-1">
                    <svg class="icon-16 fill-redRyder mr-1"><use href="../../App_Themes/clearview-default/icons/utility/info.svg#info"></use></svg>
                    <span cvLocalizedText langSection="Subscriptions_Dashboard" langKey="No_Recipient_Error">At least one recipient must be specified.</span>
                </div>
            </div>
    </div>
</div>
